import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@frontend/shadcn/components/ui/button';
import {
    Alert,
} from '@revfluence/fresh';
import { isEmpty } from 'lodash';
import React from 'react';

interface IProps {
    title: string,
    icon: React.ReactNode,
    onClick: React.MouseEventHandler<HTMLElement>,
    disabled?: boolean,
    errorMessage?: string,
}
export const RefreshManageOfferItem: React.FC<Readonly<IProps>> = React.memo((props) => {
    const {
        title, icon, onClick, disabled, errorMessage,
    } = props;
    return (
      <Button
        variant="outline"
        className="group h-10 flex items-center justify-between"
        onClick={onClick}
        disabled={disabled}
      >
        <div className="flex items-center gap-2">
          {icon}
          <p className="text-sm font-normal text-grey-6 m-0">{title}</p>
        </div>
        <div className="flex items-center gap-1">
          <span className="hidden group-hover:flex items-center gap-1 text-grey-6 text-xs font-medium transition-all">
            Edit
          </span>
          <FontAwesomeIcon icon={faChevronRight} className="text-grey-6 w-3 h-3" />
        </div>
        {!isEmpty(errorMessage) && <Alert type="info" message={errorMessage} />}
      </Button>
    );
});

RefreshManageOfferItem.displayName = 'RefreshManageOfferItem';
